if (!customElements.get('localization-form-select')) {
  customElements.define(
    'localization-form-select',
    class LocalizationFormSelect extends HTMLElement {
      constructor() {
        super();
        this.querySelector('select').addEventListener('change', this.onSelectChange.bind(this));
      }

      onSelectChange(event) {
        event.preventDefault();
        const form = this.querySelector('form');
        if (form) form.submit();
      }
    }
  );
};

// Cookie utility functions
const getCookie = (name) => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
  return null;
};

const setCookie = (name, value, days = 365) => {
  const expires = new Date();
  expires.setTime(expires.getTime() + (days * 24 * 60 * 60 * 1000));
  document.cookie = `${name}=${value};expires=${expires.toUTCString()};path=/`;
};

// geolocation popup logic
const geolocationPopup = document.querySelector('.geolocation-popup');

if (geolocationPopup) {
  const button = geolocationPopup.querySelector('.geolocation-popup-button');
  const closeButton = geolocationPopup.querySelector('.geolocation-popup-close');
  const select = geolocationPopup.querySelector('select');
  
  // Check if geolocation cookie exists
  const geolocationCookie = getCookie('geolocation_confirmed');
  
  if (!geolocationCookie || geolocationCookie === 'dismissed') {
    // Show popup if no cookie exists
    setTimeout(() => {
      geolocationPopup.showModal();
    }, 2000);
  }
  
  // Handle confirm button click
  button.addEventListener('click', () => {
    const selectedValue = select.value;
    
    // Set cookie with selected value
    setCookie('geolocation_confirmed', selectedValue);
        
    // Close the popup
    geolocationPopup.close();
  });
  
  // Handle close button click
  closeButton.addEventListener('click', () => {
    // Set a cookie to remember user dismissed the popup
    setCookie('geolocation_confirmed', 'dismissed');
    geolocationPopup.close();
  });
  
  // Handle clicking outside the popup
  geolocationPopup.addEventListener('click', (e) => {
    if (e.target === geolocationPopup) {
      setCookie('geolocation_confirmed', 'dismissed');
      geolocationPopup.close();
    }
  });
}